import { callApi } from './api'

const PAGINATION = 25

export const get = async (sitekey, id) => {
  const data = await callApi('GET', `/nps/${id}/`, sitekey)
  return data
}

export const create = async (sitekey, survey) => {
  const data = await callApi('POST', `/nps/`, sitekey, survey)
  return data
}

export const update = async (sitekey, survey) => {
  const data = await callApi('PUT', `/nps/${survey.id}/`, sitekey, survey)
  return data
}

export const deleteSurvey = async (sitekey, survey) => {
  const data = await callApi('DELETE', `/nps/${survey.id}/`, sitekey)
  return data
}

export const getAll = async sitekey => {
  const items = []
  const _load = async page => {
    const waves = await getByPage(sitekey, page)
    items.push(...waves)
    if (waves.length === PAGINATION) {
      page++
      await _load(page)
    }
  }
  await _load(0)
  return items
}

export const getByPage = async (sitekey, page) => {
  const data = await callApi('GET', `/nps/${page}/${PAGINATION}/`, sitekey)
  return data
}

export const getStats = async (sitekey, surveyId, startDate, endDate) => {
  const data = await callApi(
    'GET',
    `/nps/${surveyId}/reporting/stats/${startDate.toISOString()}/${endDate.toISOString()}/`,
    sitekey
  )
  return data
}

export const getCommentList = async (sitekey, surveyId, page, limit, type) => {
  const data = await callApi(
    'GET',
    `/nps/${surveyId}/reporting/comments/${page}/${limit}/${type}/`,
    sitekey
  )
  return data
}



// WEBPACK FOOTER //
// ./src/services/survey.api.js